import { memo } from 'react';

import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import { useTheme } from '@mui/material/styles';

import { bgBlur } from 'src/theme/css';
import { useAuthContext } from 'src/auth/hooks';

import Scrollbar from 'src/components/scrollbar';
import { NavSectionHorizontal } from 'src/components/nav-section';

import { useNavData } from './config-employee-navigation';

// ----------------------------------------------------------------------

function NavEmployee() {
  const theme = useTheme();

  const { user } = useAuthContext();

  const navData = useNavData();

  return (
    <Box
      sx={{
        m: 'auto',
        width: `100%`,
        borderBottom: (design) => `solid 1px ${design.palette.divider}`,
        boxShadow: (design) => design.customShadows.z1,
        // ...sx,
      }}
      // {...other}
    >
      <Toolbar
        sx={{
          minHeight: 60,
          ...bgBlur({
            color: theme.palette.background.default,
          }),
        }}
      >
        <Scrollbar
        // sx={{
        //   '& .simplebar-content': {
        //     display: 'flex',
        //   },
        // }}
        >
          <NavSectionHorizontal
            data={navData}
            slotProps={{
              currentRole: user?.role,
            }}
            sx={{
              ...theme.mixins.toolbar,
            }}
          />
        </Scrollbar>
      </Toolbar>

      {/* <HeaderShadow /> */}
    </Box>
  );
}

export default memo(NavEmployee);
